import React, { memo } from 'react';
import * as GStyled from '../../../styles/components';
import * as Styled from './styled';
import { ReportSnapshot } from '../../../models';
import { REPORT_CURRENCIES } from '../../../constants';
import ReportSettingPIT from './ReportSettingPIT';
import { Icon } from '../../../components';

interface ReportSettingProps {
  reportSnapshot: ReportSnapshot;
}

function ReportSettingDeleteBalance({
  reportSnapshot,
}: ReportSettingProps): JSX.Element {
  const { currency } = reportSnapshot;

  return (
    <>
      <ReportSettingPIT reportSnapshot={reportSnapshot} />
      <Styled.ReportSettingItem>
        <Icon name="currency" />
        <GStyled.Text>Currency</GStyled.Text>
        <GStyled.Text fontWeight="medium">
          {REPORT_CURRENCIES[currency].label}
        </GStyled.Text>
      </Styled.ReportSettingItem>
    </>
  );
}

export default memo(ReportSettingDeleteBalance);
